module.exports = __webpack_public_path__ + "assets/icon_copy.cafc5793.svg";